import React, { useRef, FC, memo } from 'react'

import clsx from 'clsx'
import { useHoverDirty } from 'react-use'
import styled, { css } from 'styled-components'

import { Txt, Icon } from 'src/components/atoms'

const StyledTxt = styled(Txt)<{ isActive: boolean }>`
  font-weight: ${({ isActive }) => (isActive ? '700' : 'normal')};
`
const ArrowBase = css`
  margin-left: var(--r-5);
`
const StyledArrowDownIcon = styled(Icon)<{ sortType: TableSortType }>`
  ${ArrowBase};
  transform: ${({ sortType }) => (sortType === 'asc' ? 'rotate(180deg)' : 'rotate(0)')};
`
const StyledArrowDownFillIcon = styled(Icon)<{
  sortType: TableSortType
  colorType: 'dark' | 'gray'
}>`
  ${ArrowBase};
  transform: ${({ sortType }) => (sortType === 'asc' ? 'rotate(180deg)' : 'rotate(0)')};
`

export type TableSortType = 'asc' | 'desc'

type DivProps = React.HTMLAttributes<HTMLDivElement>
type Props = {
  text: string
  isActive?: boolean
  sortType?: TableSortType
  onSelect?: () => void
} & DivProps

export const TableSortableTxt: FC<Props> = memo(
  ({ text, isActive = false, sortType = 'desc', onSelect, ...divProps }) => {
    // アクティブな項目のみ降順/昇順の切り替えを行えるようにする
    const sort = isActive ? sortType : 'desc'
    const ref = useRef(null)
    const isHovering = useHoverDirty(ref)

    return (
      <div {...divProps}>
        <div
          role="presentation"
          className="tw-flex tw-items-center tw-cursor-pointer var(--size-m)"
          onClick={onSelect}
          ref={ref}
        >
          <StyledTxt
            sizeType="s"
            isActive={isActive}
            className={clsx(
              isActive ? 'tw-text-roovPrimary-default' : 'tw-text-standardText-secondary',
              'hover:tw-text-standardText-primary'
            )}
          >
            {text}
          </StyledTxt>
          {isActive && (
            <StyledArrowDownIcon
              sortType={sort}
              path="arrow-down-circle/soft/fill"
              className="var(--r0) tw-text-roovPrimary-default"
            />
          )}
          {!isActive && (
            <StyledArrowDownFillIcon
              sortType={sort}
              colorType={isHovering ? 'dark' : 'gray'}
              path="arrow-down-circle/soft/line"
              className={clsx(
                isHovering ? 'tw-text-standardText-primary' : 'tw-text-standardText-secondary'
              )}
            />
          )}
        </div>
      </div>
    )
  }
)
